import { gql } from '@apollo/client';

export const DELETE_CATEGORY_MUTATION = gql`
    mutation deleteCategory($input: DeleteCategoryInput!) {
        result: deleteCategory(input: $input) {
            affectedRows
          }
    }
`;
